import * as STD                     from '@emersya/mpa-std';
import * as CM                           from '@emersya/mpa-components-manager';
import { Block, Link, Modal, Text } from '@emersya/mpa-components';

export interface IReplayLinkModalComponentValue {
};

export interface IReplayLinkModalComponentConfiguration extends Modal.Configuration {
};

export class ReplayLinkModalComponent extends Modal.Component<
	string,
	null
>
{
	protected override canBeClosed() : boolean {
		return true;
	};

	protected override onOpen() {
	};

	protected override onClose() {
	};

	protected override async onValidate(){
		// await so build don't stop on it
		await Promise.resolve();
		return null;
	};

	override async component_initialize() {
		await super.component_initialize();

		const title = this.component_find('@:header.title') as Block.Component;
		const logoConfirmation = await title.component_find('@@').component_instantiateOuterChild({
			type: 'image',
			id: 'logoConfirmation',
			tree: this.component_tree,
			slot: 'titleIcon',
			isSlot: false,
			beforeNode: title.component_DOM,
			configuration: {}
		});

		void logoConfirmation;
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);

		const logoConfirmation = this.component_find('@:header.logoConfirmation');

		if (!logoConfirmation.component_configuration.URL) {
			await logoConfirmation.component_disable();
		}
	};

	override async use(replayLink : string) : Promise<TModalResponse<null>>  {
		const link = <Link.Component> this.component_find('@:content.replayLinkContainer.replay');
	 	link.updateHref(replayLink);
	 	link.updateText(replayLink);

		const textCopy = <Text.Component> this.component_find('@:content.replayLinkContainer.copyText');
		textCopy.component_DOM.classList.remove('copied');

		return await super.use(replayLink);
	}

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IReplayLinkModalComponentConfiguration
	)
	{
		super(descriptor, configuration);
        this.component_DOM = <HTMLDivElement> STD.DOM.factory({
			tag : 'div'
		});
	};

	async copy() {
		const link = <Link.Component> this.component_find('@:content.replayLinkContainer.replay');
		if (!link.component_DOM.href) {
			return;
		}
		await navigator.clipboard.writeText(link.component_DOM.href);
		const textCopy = <Text.Component> this.component_find('@:content.replayLinkContainer.copyText');
		textCopy.component_DOM.classList.add('copied');
	}
};
export namespace NS {
	export type Component = ReplayLinkModalComponent;
	export const Component = ReplayLinkModalComponent;
	export type Configuration = IReplayLinkModalComponentConfiguration;
}
import './ProductReplayLinkModal.scss';
import manifestXMLSource            from './ProductReplayLinkModal.xml';
import { TModalResponse } from '../../../../../../../MPA-Components/src/Modal/Modal';

CM.Manager.declare({
	id :       'product-replayLinkModal',
	type :     ReplayLinkModalComponent,
	manifest : manifestXMLSource
});
